import * as React from 'react';
import { TZUtils } from 'lib/tzutils';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';
import { DateRange } from 'portcall/daterangeselector/model';
import { parseDateRange, outboundDateRangeParams } from 'portcall/daterangeselector/routeParams';
import { BerthClosuresDashboard, BerthClosuresDashboardParams } from './model';
import { BerthClosuresDashboardView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { parseDate } from 'common/services/routeParams';

export function BerthClosuresDashboardRoute(
    model : (params : BerthClosuresDashboardParams) => BerthClosuresDashboard,
    appWrapper : AppWrapper,
    tzutils : TZUtils,
    request : Location
) : IRoute {
    const m = model(inboundParams(request, tzutils));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <BerthClosuresDashboardView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
}

function inboundParams(request : Location, tzutils : TZUtils) : BerthClosuresDashboardParams {
    const
        orgId = request.params['orgId'],
        range = request.params['range'],
        from = request.params['from'],
        to = request.params['to'],
        filter = request.params['filter'];

    return {
        orgId: orgId === undefined ? undefined : +orgId,
        range: range === undefined ? DateRange.ThisMonth : parseDateRange(range),
        from: from === undefined ? undefined : parseDate(from, tzutils),
        to: to === undefined ? undefined : parseDate(to, tzutils),
        filter
    };
}

function outboundParams(request : Location, m : BerthClosuresDashboard) {
    const params = {} as LocationParams;
    params['orgId'] = m.OrgId + '';
    outboundDateRangeParams(m.DateRangeSelector, params, DateRange.ThisMonth, { range: 'range', from: 'from', to: 'to' });
    if (m.Filter()) params['filter'] = m.Filter();
    return new Location(request.name, params);
}



// WEBPACK FOOTER //
// ./apps/portcall/berthclosuresdashboard/route.tsx